<template>
  <div class="part section1">
    <div class="relative">
      <div class="video-container">
        <video
          class="top-video"
          ref="myVideo"
          loop="loop"
          muted
          playsinline
          src="../assets/Lark20250329-140928.mp4"
        ></video>
      </div>
      <img
        class="btn2 btn link-item1"
        src="../assets/32.png"
        v-if="flase"
        @click="navLink('https://telgather.gitbook.io/web3pvz-deadpaper/about-dr.pump')"
      >
      <img
        class="btn1 btn link-item2"
        src="../assets/31.png"
        v-if="flase"
        @click="navLink('https://x.com/DrZombiePump')"
      >
      <!-- <div
        class="btn1 btn link-item3"
        @click="navLink('https://lin.ee/qDw4ZTC')"
      >
        <img
          class="line-icon"
          src="../assets/line-icon.png"
        >
        <div class="telegram-text">LINE DAPP</div>
      </div>
      <div
        class="btn1 btn link-item4"
        @click="navLink('https://t.me/Web3PlantsZombiesBot')"
      >
        <img
          class="telegram-icon"
          src="../assets/telegram-icon.png"
        >
        <div class="telegram-text">TELEGRAM</div>
      </div> -->
      <div class="under-line">

        <div class="icons">
          <img
            class="telegram-icon"
            src="../assets/icons/line.png"
            @click="navLink('https://lin.ee/qDw4ZTC')"
          >
          <img
            class="telegram-icon"
            src="../assets/icons/telgather.png"
            @click="navLink('https://t.me/Telgatherminigames')"
          >
          <img
            class="telegram-icon"
            src="../assets/icons/youtube.png"
            @click="navLink('https://www.youtube.com/@web3pvz')"
          >
          <img
            class="telegram-icon"
            src="../assets/icons/m.png"
            @click="navLink('https://medium.com/@telgather.mingames')"
          >
          <img
            class="telegram-icon"
            src="../assets/icons/x.png"
            @click="navLink('https://x.com/DrZombiePump')"
          >
        </div>

        <div class="super-link flex">
          <div
            class="btn1 link-item3"
            @click="navLink('https://lin.ee/qDw4ZTC')"
          >
            <img
              class="super-line-icon"
              src="../assets/icons/playleft.png"
            >
          </div>
          <div
            class="btn1 link-item4"
            @click="navLink('https://t.me/Web3PlantsZombiesBot')"
          >
            <img
              class="super-telegram-icon"
              src="../assets/icons/playright.png"
            >
          </div>
        </div>
      </div>

    </div>
    <div
      class="right-part"
      v-if="false"
      style="padding-top:10vh"
    >
      <!-- <img
          class="itemv"
          src="../assets/phone2.png"
        > -->
      <div class="videocontainer itemv">
        <video
          class="videoo"
          ref="2"
          loop="loop"
          muted
          playsinline
          src="../assets/Lark20250329-140928.mp4"
        ></video>
      </div>

    </div>
    <div class="partners">
      <div><img
          class="title"
          src="../assets/partner/title.png"
        ></div>
      <div class="info">
        <img
          class="item"
          src="../assets/partner/line.png"
        >
        <img
          class="item"
          src="../assets/partner/kaia.png"
        >
        <img
          class="item"
          src="../assets/partner/dapp.png"
        >
        <img
          class="item"
          src="../assets/partner/hash.png"
        >
        <img
          class="item"
          src="../assets/partner/abstract.png"
        >
        <img
          class="item"
          src="../assets/partner/okx.png"
        >
        <img
          class="item"
          src="../assets/partner/gate.png"
        >
        <img
          class="item"
          src="../assets/partner/telgather.png"
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HomeTopPart',
  data () {
    return {
      isShow: false
    }
  },
  mounted () {
    this.$refs.myVideo.play()
  },
  methods: {
    navLink (url) {
      window.open(url)
    }
  }
}
</script>
<style lang="scss" scoped>
.video-container {
  width: 75vw;
  max-width:1200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}

.section1 {
  width: 100%;
  margin: 0 auto;
  height: auto;
  .partners {
    position: relative;
    zoom:0.75;
    left: 50%;
    width: 90vw;
    transform: translateX(-50%);
    color: white;
    .title {
      margin: 50px;
      width: 22vw;
    }
    .info {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      width: 100%;
    }
    .item {
      width: 20vw;
      height: 7vw;
      margin: 20px 0px 20px 0px;
      transition: all 0.25s linear;
    }
    .item:hover {
      transform: scale(1.2);
    }
  }

  .under-line {
    display: flex;
    flex-direction: column;
  }

  @media (max-width: 768px) {
    .under-line {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .partners {
      width: 90vw;
      zoom:1;
    }
    .icons {
      order: 2;
    }

    .super-link {
      order: 1;
      margin-bottom: 20px;
    }
  }
  .top-video {
    width: 100%;
    border-radius: 20px;
  }

  .icons {
    display: flex;
    justify-content: center;
  }
  .big-item {
    /*position: absolute;
    width: 1148px;
    left: 40px;*/
  }
  .link-item1 {
    width: 267px;
  }
  .link-item2 {
    width: 267px;
  }
  .super-link {
    justify-content: center;
    transform: scale(0.7);
    .link-item3 {
      left: 674px;
      top: 1259px;
      transition: all 0.25s linear;
      transform-origin: right center;
      .super-line-icon {
        width: 184px;
        height: 118px;
        cursor: pointer;
      }
    }
    .link-item3:hover {
      transform: scale(1.1);
    }
    .link-item4 {
      // position: absolute;
      left: 810px;
      top: 659px;
      transition: all 0.25s linear;
      transform-origin: left center;
      .super-telegram-icon {
        width: 173px;
        height: 120px;
        margin-top: -2px;
        cursor: pointer;
      }
    }
    .link-item4:hover {
      transform: scale(1.1);
    }
  }

  .telegram-text {
    color: white;
    padding: 5px 10px 5px 10px;
    width: 98px;
    height: 23px;
    line-height: 23px;
    font-size: 16px;
    background-color: rgba($color: #2d3b53, $alpha: 0.6);
    border-radius: 10px;
  }
  .telegram-icon {
    width: 12vw;
    height: 12vw;
    margin: 0px 10px 0px 10px;
    display: block;
    cursor: pointer;
    transition: all 0.25s linear;
  }
  .telegram-icon:hover {
    transform: scale(1.2);
  }
  @media (min-width: 1500px) {
    .telegram-icon {
      width: 5vw;
      height: 5vw;
    }
    .partners {
      width: 70vw;
    }
  }
  .line-icon {
    width: 80px;
    margin: 0 auto;
    display: block;
  }

  .right-part {
    position: absolute;
    right: 175px;
    top: 130px;
    border-radius: 30px;
    -webkit-filter: brightness(108.5%);
    filter: brightness(108.5%);
    .videocontainer {
      width: 431px;
      height: 798px;
      z-index: 100;
    }

    .videoo {
      width: 100%;
      height: 100%;
      object-fit: contain;
      margin-left: 0%;
      margin-top: 0%;
    }
  }
}
</style>
